enum StyleType {
  BLOCK = 'block',
  INLINE = 'inline',
  LINK = 'link',
  DISPLAY = 'display',
  DOWNLOAD = 'download'
}

export default StyleType;
